import './App.css';

import {ContextProvider} from "./context/context";

import Header from './components/header/header';
import Main from './components/main/main';
import Footer from './components/footer/footer';
import Modal from './components/modal/modal';
import ParallaxBackground from "./components/parallaxbackground/parallaxbackground";
import StarDust from "./components/stardust/stardust";




function App() {
  return (
      <>
      <ParallaxBackground />
      <StarDust />

      <div className="App">
        <ContextProvider>
          <Header />
          <Main />
          <Footer />
          <Modal />
        </ContextProvider>
      </div>
      </>
  );
}

export default App;